export default __webpack_public_path__ + "static/steam_b.9a306586bf1692301120daf8669be5eb.png";